import styled from 'styled-components'

import { FilePreviewStyled } from '@ui/blocks/FilePreview/styles/FilePreviewStyled'
import { FileViewerPreviewSectionStyled } from '@ui/blocks/FileViewer/components/FileViewerPreviewSection/styles/FileViewerPreviewSectionStyled'
import { FileViewerStyled } from '@ui/blocks/FileViewer/styles/FileViewerStyled'

export const FileViewerModalStyled = styled.div`
  width: 100%;
  height: 100%;
  position: relative;

  .close-button {
    position: absolute;
    right: ${(props) => props.theme.typography.pxToRem(16)};
    top: ${(props) => props.theme.typography.pxToRem(16)};
    z-index: 1;
  }

  ${FileViewerPreviewSectionStyled} {
    position: relative;
  }

  ${FileViewerStyled} {
    background: none;
  }

  ${FilePreviewStyled} {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: auto;
    height: auto;
    background: none;
  }

  ${FilePreviewStyled}.filetype-pdf {
    margin: ${(props) => props.theme.typography.pxToRem(60)};
    margin-bottom: 0;
  }
`
